// Custom components
import React from "react";
import { Controller } from "react-hook-form";

function InputField(props) {
  const {
    label,
    id,
    extra,
    placeholder,
    cols,
    rows,
    state,
    disabled,
    control,
    name,
    rules,
    ...rest
  } = props;

  const renderTextarea = ({ field = {}, error } = {}) => {
    const textareaId = id || name;
    const textareaState = error ? "error" : state;

    return (
      <div className={`${extra}`}>
        {label && (
          <label
            htmlFor={textareaId}
            className="ml-3 mb-2 text-sm font-bold text-navy-700 dark:text-white"
          >
            {label}
          </label>
        )}
        <div>
          <textarea
            {...rest}
            {...field}
            cols={cols}
            rows={rows}
            placeholder={placeholder}
            disabled={disabled}
            value={field.value ?? rest.value ?? ""}
            onChange={field.onChange || rest.onChange}
            className={`flex w-full items-center justify-center rounded-xl border bg-white/0 pl-3 pt-3 text-sm outline-none ${
              disabled === true
                ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                : textareaState === "error"
                ? "!border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                : textareaState === "success"
                ? "!border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                : "border-gray-200 dark:!border-white/10 dark:text-white"
            }`}
            name={field.name || name || id}
            id={textareaId}
          />
        </div>
        {error?.message && <p className="mt-1 text-sm text-red-600">{error.message}</p>}
      </div>
    );
  };

  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => renderTextarea({ field, error: fieldState.error })}
      />
    );
  }

  return renderTextarea();
}

export default InputField;
